import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { QuickPickViewState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    AdditionalInfo,
    MatchBetMarketTitle,
    MatchBetMarketWrapper,
    MatchBetSelectionWrapper,
    RowCelName,
    RowCelPlace,
    SelectionMatchBet,
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MatchBet/MatchBet.style';
import { ChevronIcon } from 'src/assets/new-icon/ChevronIcon';
import { action, observable, makeAutoObservable } from 'mobx';
import { TypeId } from 'src_common/common/websocket2/type';

interface MatchBetRowPropsType {
    userId: number;
    quickPickState: QuickPickViewState;
    marketId: TypeId.MarketId;
}

class RowState {
    @observable isOpen: boolean;

    constructor() {
        this.isOpen = true;
        makeAutoObservable(this);
    }

    @action onToggleMarket = (): void => {
        this.isOpen = !this.isOpen;
    };
}

export const MatchBetRow = observer('MatchBetRow', (props: MatchBetRowPropsType) => {
    const appState = useAppStateContext();
    const market = appState.websocketV2.getMarket(props.marketId);
    const [rowState] = useState(() => new RowState());
    const event = props.quickPickState.getSelectedEvent;

    if (market === null || market.active === false || event === null) {
        return null;
    }
    const ewInfo =
        market.eachWayOffered === true && market.eachWayTermsReduction !== undefined
            ? ` - EW: ${market.eachWayTermsReduction} - Places ${market.eachWayTermsPlaces}`
            : null;

    return (
        <MatchBetMarketWrapper>
            <MatchBetMarketTitle onClick={rowState.onToggleMarket}>
                <ChevronIcon position={rowState.isOpen ? 'down' : 'up'} />
                {market.name}
                {ewInfo}
            </MatchBetMarketTitle>
            {rowState.isOpen === true
                ? market.selections.map((selection) => {
                      const isUnnamedFavourite = selection.templateId === 'unnamed-favourite';
                      const nonRunner =
                          selection.computedMetaData?.status === 'Non-Runner' || selection.resultType === 'void';
                      const jockey = selection.metaDataJockey;
                      const trainer = selection.metaDataTrainer;
                      const number = selection.metaDataNumber;
                      const drawn = selection.metaDataDrawn;
                      const courseType = event.feedCourseType;

                      return (
                          <MatchBetSelectionWrapper
                              key={`match-bet${selection.id}`}
                              nonRunner={nonRunner}
                          >
                              <RowCelPlace>
                                  {number ? number : null}
                                  <br />
                                  {drawn && courseType === 'Flat' ? `(${drawn})` : null}
                              </RowCelPlace>
                              <RowCelName>
                                  {selection.name || 'n/a'}
                                  {isUnnamedFavourite ? null : (
                                      <AdditionalInfo>
                                          {jockey && trainer ? `${jockey} / ${trainer}` : null}
                                      </AdditionalInfo>
                                  )}
                              </RowCelName>
                              <SelectionMatchBet
                                  key={`${selection.id}-shown`}
                                  className='main-market-column__selection'
                                  userId={props.userId}
                                  marketId={selection.marketId}
                                  selectionId={selection.id}
                                  allowShowSp={true}
                              />
                          </MatchBetSelectionWrapper>
                      );
                  })
                : null}
        </MatchBetMarketWrapper>
    );
});
